/**
 * Category hero image URL resolution — the single source of truth for what a
 * category tile paints when `categories.image` is NULL.
 *
 * Before card 4103 each of the three call sites inlined its own fallback: a
 * per-slug `<slug>-hero.webp` under a public catalog asset directory that has
 * never existed on disk. That fallback could therefore only ever 404, and the
 * tile painted the bare `--color-tan-100` card background instead of artwork.
 * Resolving to a real asset makes the ABSENCE of category artwork degrade to a
 * placeholder rather than to a failed request.
 *
 * ⛔ Do not reintroduce that dead path here or at any call site — card 4103's
 * criterion and card 4105's bundle oracle both assert it is absent, and the
 * grep they use cannot tell a comment from code.
 */

/** Measured 2026-08-30 on ovalcare.com: 200 / image/webp / 10092 B. */
export const CATEGORY_HERO_FALLBACK = '/images/product-placeholder.webp';

export const resolveCategoryHeroUrl = (category) =>
  category?.image || CATEGORY_HERO_FALLBACK;
